"use client";

import { c as _c } from "react/compiler-runtime";
import { GET_REVIEWS_QUERY, ReviewData } from "@/gql/review";
import { logger } from "@/utils/logger";
import { useLazyQuery } from "@apollo/client";
import { useCallback } from "react";
interface UseTestimonialsRefreshProps {
  limit?: number;
}
interface UseTestimonialsRefreshReturn {
  testimonials: ReviewData[];
  isLoading: boolean;
  error: string | null;
  refreshTestimonials: () => Promise<void>;
}
export const useTestimonialsRefresh = t0 => {
  const $ = _c(13);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    limit: t2
  } = t1;
  const limit = t2 === undefined ? 10 : t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      fetchPolicy: "network-only"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [getReviews, t4] = useLazyQuery(GET_REVIEWS_QUERY, t3);
  const {
    data,
    loading,
    error
  } = t4;
  if (error) {
    logger.error("Error fetching testimonials:", error);
  }
  let t5;
  if ($[3] !== getReviews || $[4] !== limit) {
    t5 = async () => {
      ;
      try {
        await getReviews({
          variables: {
            params: {
              get: {
                limit
              }
            }
          }
        });
      } catch (t6) {
        const error_0 = t6;
        logger.error("Error refreshing testimonials:", error_0);
      }
    };
    $[3] = getReviews;
    $[4] = limit;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const refreshTestimonials = t5;
  let t6;
  if ($[6] !== data?.reviews?.get?.data) {
    t6 = data?.reviews?.get?.data || [];
    $[6] = data?.reviews?.get?.data;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = error?.message || null;
  let t8;
  if ($[8] !== loading || $[9] !== refreshTestimonials || $[10] !== t6 || $[11] !== t7) {
    t8 = {
      testimonials: t6,
      isLoading: loading,
      error: t7,
      refreshTestimonials
    };
    $[8] = loading;
    $[9] = refreshTestimonials;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};